// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__13HNe","alert":"SettungsInbox_alert__2QsYR"};